// Export the Component Definition for use in Contentful Studio
export {ActivityCarouselContentfulComponentDefinition} from './activityCarouselContentfulDefinition';
export {default} from './ActivityCarousel';
